<script>
  let { title, subtitle = null, children = null } = $props();
</script>

<header class="mb-6 flex flex-wrap items-start justify-between gap-4">
  <div>
    <h1 class="text-xl font-semibold">{title}</h1>
    {#if subtitle}<p class="mt-1 text-sm p-muted">{subtitle}</p>{/if}
  </div>
  {#if children}<div class="flex items-center gap-2">{@render children()}</div>{/if}
</header>
